export default "__VITE_ASSET__DRTx4CpH__"